import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../styleVars';
import { Typography } from '../typography/Typography';
import { Image } from './Image';
import { ImageEntity } from './entitySpec';
var bottomLeftPositionStyle = 'bottom: 0; left: -5px';
var defaultPositionStyle = 'bottom: 0; right: -5px;';
var badgePositionStyle = {
  1: defaultPositionStyle,
  2: 'top: 0; right: -5px;',
  3: 'top: 0; left: -5px;',
  4: 'top: 15px; left: -5px;',
  5: 'top: 30px; left: -5px;',
  6: bottomLeftPositionStyle,
  default: defaultPositionStyle
};
var Container = styled(Typography).withConfig({
  componentId: "sc-vqxrsk-0"
})(["background-color:", ";box-shadow:0 0 2px 0 ", ";border-radius:50%;", ";position:absolute;display:inline-flex;width:20px;height:20px;z-index:2;justify-content:center;align-items:center;align-content:center;img{display:block;margin:auto;}"], COLORS.white, COLORS.grey, function (props) {
  return badgePositionStyle[props.position] || badgePositionStyle['default'];
});

var ImageBadge = function ImageBadge(_ref) {
  var value = _ref.value,
      position = _ref.position,
      className = _ref.className,
      fit = _ref.fit;
  return /*#__PURE__*/React.createElement(Container, {
    position: position,
    className: className,
    variant: "caption3"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    src: value,
    width: 16,
    height: 16,
    fit: fit
  }));
};

var IconBadge = function IconBadge(_ref2) {
  var value = _ref2.value,
      position = _ref2.position,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(Container, {
    position: position,
    className: className,
    variant: "caption3"
  }, value);
};

var TextBadge = function TextBadge(_ref3) {
  var value = _ref3.value,
      position = _ref3.position,
      className = _ref3.className;
  return /*#__PURE__*/React.createElement(Container, {
    position: position,
    className: className,
    variant: "caption3"
  }, /*#__PURE__*/React.createElement("span", null, value));
};

export { ImageBadge, IconBadge, TextBadge };
//# sourceMappingURL=Badge.js.map